module.exports = __webpack_public_path__ + "static/media/righthg.34b6501e.png";